import { Link } from "react-router-dom";
export function NotFound() {
    return (
        <div className="notFound">
            <h1 style={{fontWeight: "bold"}}>Oops how did you get here!</h1>
            <h2 style={{color: "red", fontFamily: "sans-serif", fontWeight: "bold"}}>404 Page Not Found</h2>
            <Link className="link-btn" to="/dashboard/page/1"><button className="return-home-button">Return Home</button></Link>
        </div>
    )
}